function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "A1A4AA94-DD22-4DB9-951C-7737B90A20DB");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with sketchtool.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "User-Interface",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Home",
  transform: "translate(-510.000000, -2704.000000)",
  strokeWidth: 1.5
}, React.createElement("g", {
  id: "Group-6",
  transform: "translate(62.000000, 2474.000000)"
}, React.createElement("g", {
  id: "Group-5-Copy",
  transform: "translate(336.000000, 181.000000)"
}, React.createElement("g", {
  id: "icon-chip",
  transform: "translate(111.000000, 50.000000)"
}, React.createElement("g", {
  id: "bg",
  fill: "#FFFFFF",
  stroke: "#DADADA"
}, React.createElement("polygon", {
  id: "Polygon",
  points: "42 3 78.373067 24 78.373067 66 42 87 5.62693304 66 5.62693304 24"
}), React.createElement("path", {
  d: "M42,84 C43.6568542,84 45,85.3431458 45,87 C45,88.6568542 43.6568542,90 42,90 C40.3431458,90 39,88.6568542 39,87 C39,85.3431458 40.3431458,84 42,84 Z M80.3442101,63.5 C81.779088,64.3284271 82.2707135,66.1631983 81.4422863,67.5980762 C80.6138592,69.0329541 78.779088,69.5245795 77.3442101,68.6961524 C75.9093323,67.8677253 75.4177068,66.0329541 76.2461339,64.5980762 C77.074561,63.1631983 78.9093323,62.6715729 80.3442101,63.5 Z M8.22500925,64.5 C9.05343638,65.9348779 8.56181091,67.7696491 7.12693304,68.5980762 C5.69205517,69.4265033 3.85728395,68.9348779 3.02885683,67.5 C2.2004297,66.0651221 2.69205517,64.2303509 4.12693304,63.4019238 C5.56181091,62.5734967 7.39658213,63.0651221 8.22500925,64.5 Z M7.59807621,21.5 C9.03295408,22.3284271 9.52457955,24.1631983 8.69615242,25.5980762 C7.8677253,27.0329541 6.03295408,27.5245795 4.59807621,26.6961524 C3.16319834,25.8677253 2.67157288,24.0329541 3.5,22.5980762 C4.32842712,21.1631983 6.16319834,20.6715729 7.59807621,21.5 Z M80.9711432,22.5 C81.7995703,23.9348779 81.3079448,25.7696491 79.873067,26.5980762 C78.4381891,27.4265033 76.6034179,26.9348779 75.7749907,25.5 C74.9465636,24.0651221 75.4381891,22.2303509 76.873067,21.4019238 C78.3079448,20.5734967 80.142716,21.0651221 80.9711432,22.5 Z M42,0 C43.6568542,0 45,1.34314575 45,3 C45,4.65685425 43.6568542,6 42,6 C40.3431458,6 39,4.65685425 39,3 C39,1.34314575 40.3431458,0 42,0 Z",
  id: "Combined-Shape"
})), React.createElement("g", {
  id: "ai",
  transform: "translate(21.000000, 24.000000)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, React.createElement("line", {
  x1: 13.3636364,
  y1: 3.81818182,
  x2: 13.3636364,
  y2: 8.28226376e-14,
  id: "Path",
  stroke: "#27294F"
}), React.createElement("line", {
  x1: 28.6363636,
  y1: 3.81818182,
  x2: 28.6363636,
  y2: 8.28226376e-14,
  id: "Path",
  stroke: "#27294F"
}), React.createElement("line", {
  x1: 21,
  y1: 3.81818182,
  x2: 21,
  y2: 8.28226376e-14,
  id: "Path",
  stroke: "#27294F"
}), React.createElement("line", {
  x1: 42,
  y1: 28.6363636,
  x2: 38.1818182,
  y2: 28.6363636,
  id: "Path",
  stroke: "#27294F"
}), React.createElement("line", {
  x1: 42,
  y1: 13.3636364,
  x2: 38.1818182,
  y2: 13.3636364,
  id: "Path",
  stroke: "#27294F"
}), React.createElement("line", {
  x1: 42,
  y1: 21,
  x2: 38.1818182,
  y2: 21,
  id: "Path",
  stroke: "#27294F"
}), React.createElement("line", {
  x1: 3.81818182,
  y1: 28.6363636,
  x2: -2.64566147e-12,
  y2: 28.6363636,
  id: "Path",
  stroke: "#27294F"
}), React.createElement("line", {
  x1: 3.81818182,
  y1: 13.3636364,
  x2: -2.64566147e-12,
  y2: 13.3636364,
  id: "Path",
  stroke: "#27294F"
}), React.createElement("line", {
  x1: 3.81818182,
  y1: 21,
  x2: -2.64566147e-12,
  y2: 21,
  id: "Path",
  stroke: "#27294F"
}), React.createElement("line", {
  x1: 13.3636364,
  y1: 42,
  x2: 13.3636364,
  y2: 38.1818182,
  id: "Path",
  stroke: "#27294F"
}), React.createElement("line", {
  x1: 28.6363636,
  y1: 42,
  x2: 28.6363636,
  y2: 38.1818182,
  id: "Path",
  stroke: "#27294F"
}), React.createElement("line", {
  x1: 21,
  y1: 42,
  x2: 21,
  y2: 38.1818182,
  id: "Path",
  stroke: "#27294F"
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#27294F",
  x: 3.81818182,
  y: 3.81818182,
  width: 34.3636364,
  height: 34.3636364,
  rx: 2
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#0276F1",
  x: 11.4545455,
  y: 11.4545455,
  width: 19.0909091,
  height: 19.0909091
})))))));

var SvgChip = function SvgChip(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "82px",
    height: "92px",
    viewBox: "0 0 82 92",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChip, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };